
/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
/* eslint-disable import/first */
import katex from 'katex'
import 'katex/dist/katex.css'
import './styles.css'

window.katex = katex

import 'react-quill/dist/quill.snow.css'

// MathQuill dependency
import './jquery'

import 'mathquill/build/mathquill.js'
import 'mathquill/build/mathquill.css'
import mathquill4quill from 'mathquill4quill'
import 'mathquill4quill/mathquill4quill.css'
// react-quill components
import ReactQuill, { Quill } from "react-quill";

// react-quill styles
import "react-quill/dist/quill.snow.css";

// Custom styles for the MDEditor
import MDEditorRoot from "components/MDEditor/MDEditorRoot";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";
import { createRef, useEffect } from 'react'

//@ts-ignore



// declaring types for the MDEditor
interface Props {
  [key: string]: any;
  cardsLength?: number
  isEditing?: boolean
}

function MDEditor({ cardsLength, isEditing = false, ...props }: Props): JSX.Element {

  const ColorAttributor = Quill.import("attributors/style/color");
  ColorAttributor.whitelist = [];
  Quill.register(ColorAttributor);


  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const options = {
    displayDeleteButtonOnHistory: true,
    displayHistory: true,
    operators: [
      ['\\sqrt{x}', '\\sqrt'],
      ['\\sqrt[3]{x}', '\\sqrt[3]{}'],
      ['\\sqrt[n]{x}', '\\nthroot'],
      ['\\frac{x}{y}', '\\frac'],
    ]
  }


  const reactQuill = createRef()
  useEffect(() => {
    const enableMathQuillFormulaAuthoring = mathquill4quill({ Quill, katex })
    enableMathQuillFormulaAuthoring(
      //@ts-ignore
      reactQuill.current.editor,
      options
    )
    //@ts-ignore
    const div = reactQuill.current?.editor.scrollingContainer
    const timer = setTimeout(() => {
      var h1 = document.createElement('h1');
      if (!isEditing) {
        div.replaceChild(h1, div.children[0])
      }
      div.children[0].className = 'ql-align-center'
    }, 500);
    return () => clearTimeout(timer);
  }, [cardsLength])

  return (
    <MDEditorRoot ownerState={{ darkMode }}>
      {//@ts-ignore
        (<ReactQuill ref={reactQuill} modules={{
          formula: true,
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline',],
            [{ align: '' }, { align: 'center' }],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link'],
            ['formula', 'clean'],
          ],
        }} theme="snow" {...props} />) as any}
    </MDEditorRoot>
  );
}

export default MDEditor;
